// Layelle theme — minimal interactions (v4-mobile-nav)
(function () {
  function setupMobileNav() {
    const ham = document.querySelector('[data-hamburger]');
    const drawer = document.querySelector('[data-nav]');
    if (!ham || !drawer) return;

    const setOpen = (open) => {
      document.body.dataset.navOpen = open ? 'true' : 'false';
      ham.setAttribute('aria-expanded', open ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    };

    ham.addEventListener('click', () => {
      const open = document.body.dataset.navOpen === 'true';
      setOpen(!open);
    });

    drawer.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => setOpen(false));
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.body.dataset.navOpen === 'true') setOpen(false);
    });

    // Close drawer if viewport grows past mobile breakpoint
    const mq = window.matchMedia('(min-width: 801px)');
    if (mq.addEventListener) mq.addEventListener('change', () => { if (mq.matches) setOpen(false); });
  }

  function setupCollectionFilter() {
    // Category filter — client-side show/hide by product type (current page).
    const catSelect = document.querySelector('[data-sort-by]');
    if (catSelect) {
      catSelect.addEventListener('change', function () {
        const val = this.value;
        let visible = 0;
        document.querySelectorAll('[data-product-type]').forEach((card) => {
          const type = card.dataset.productType;
          const show = val === 'all' || type === val;
          card.style.display = show ? '' : 'none';
          if (show) visible++;
        });
        const countEl = document.querySelector('[data-product-count]');
        if (countEl) countEl.textContent = visible;
      });
    }
    // Sort — Shopify-native server-side sort via the sort_by URL parameter.
    const sortSelect = document.querySelector('[data-collection-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }
  }

  // --- AJAX cart: update header badge without full page reload ---
  async function fetchCart() {
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!r.ok) return null;
      return await r.json();
    } catch (e) { return null; }
  }

  function paintCartCount(itemCount) {
    document.querySelectorAll('.site-header__cart, .site-header__cart-icon').forEach((wrap) => {
      let badge = wrap.querySelector('.site-header__cart-count');
      if (itemCount > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'site-header__cart-count';
          wrap.appendChild(badge);
        }
        badge.textContent = itemCount;
        badge.style.display = '';
      } else if (badge) {
        badge.remove();
      }
    });
  }

  async function refreshCartCount() {
    const cart = await fetchCart();
    if (cart) paintCartCount(cart.item_count);
  }

  function setupAjaxCart() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      if (form.dataset.layelleAjax === '1') return;
      form.dataset.layelleAjax = '1';
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const submitBtn = form.querySelector('button[type="submit"], button:not([type])');
        const originalLabel = submitBtn?.textContent;
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }
        try {
          const fd = new FormData(form);
          const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          if (!res.ok) throw new Error('add failed');
          await refreshCartCount();
          if (submitBtn) {
            submitBtn.textContent = 'Added';
            setTimeout(() => { submitBtn.textContent = originalLabel || 'Add to Cart'; submitBtn.disabled = false; }, 1400);
          }
        } catch (err) {
          form.submit();
        }
      });
    });
    // Refresh on page show after bfcache navigation
    window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCartCount(); });
  }

  // --- Cart page: qty controls + remove button, live AJAX updates ---
  function moneyFormat(cents) {
    // Try to read Shopify's format if available; fall back to USD
    const fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    const dollars = (cents / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, dollars)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, dollars.replace('.', ','));
  }

  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!res.ok) return null;
    return await res.json();
  }

  function repaintCart(cart) {
    if (!cart) return;
    // Sync per-line states (remove zero-qty lines from DOM)
    document.querySelectorAll('[data-cart-line]').forEach((row) => {
      const key = row.dataset.cartLine;
      const live = cart.items.find((it) => it.key === key);
      if (!live) {
        row.remove();
      } else {
        const qtyInput = row.querySelector('[data-cart-qty-input]');
        if (qtyInput && parseInt(qtyInput.value, 10) !== live.quantity) qtyInput.value = live.quantity;
        const lineTotal = row.querySelector('[data-cart-line-total]');
        if (lineTotal) lineTotal.textContent = moneyFormat(live.final_line_price);
        row.removeAttribute('data-loading');
      }
    });
    const subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);
    const countLabel = document.querySelector('[data-cart-item-count-label]');
    if (countLabel) countLabel.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;
    paintCartCount(cart.item_count);
    // If empty, reload the page so the empty-state markup renders
    if (cart.item_count === 0 && document.querySelector('[data-cart-form]')) {
      window.location.href = window.location.pathname;
    }
  }

  function setupCartPage() {
    const section = document.querySelector('[data-cart-section]');
    if (!section) return;

    section.addEventListener('click', async (e) => {
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        const row = removeBtn.closest('[data-cart-line]');
        if (!row) return;
        row.setAttribute('data-loading', 'true');
        const cart = await changeLine(row.dataset.cartLine, 0);
        repaintCart(cart);
        return;
      }
      const stepBtn = e.target.closest('[data-qty-step]');
      if (stepBtn) {
        const row = stepBtn.closest('[data-cart-line]');
        if (!row) return;
        const input = row.querySelector('[data-cart-qty-input]');
        const current = parseInt(input.value, 10) || 0;
        const next = Math.max(0, current + parseInt(stepBtn.dataset.qtyStep, 10));
        if (next === current) return;
        row.setAttribute('data-loading', 'true');
        input.value = next;
        const cart = await changeLine(row.dataset.cartLine, next);
        repaintCart(cart);
      }
    });

    section.addEventListener('change', async (e) => {
      const input = e.target.closest('[data-cart-qty-input]');
      if (!input) return;
      const row = input.closest('[data-cart-line]');
      const qty = Math.max(0, parseInt(input.value, 10) || 0);
      row.setAttribute('data-loading', 'true');
      const cart = await changeLine(row.dataset.cartLine, qty);
      repaintCart(cart);
    });
  }

  // --- PDP: thumbnail swap + qty controls + variant picker ---
  function setupPdp() {
    const wrap = document.querySelector('.pdp-wrap');
    if (!wrap) return;

    // Thumbnail clicks swap the main image
    const mainImg = wrap.querySelector('#pdp-main-img');
    wrap.querySelectorAll('.pdp__thumb').forEach((btn) => {
      btn.addEventListener('click', () => {
        const url = btn.dataset.mediaUrl;
        if (!url || !mainImg) return;
        mainImg.src = url;
        wrap.querySelectorAll('.pdp__thumb').forEach((t) => t.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });

    // Qty buttons
    const qtyInput = wrap.querySelector('[data-pdp-qty-input]');
    wrap.querySelectorAll('[data-pdp-qty-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.pdpQtyStep, 10);
        const current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, current + step);
      });
    });

    // Variant picker — when user clicks a value, find the matching variant by combining options
    const optionState = {};
    wrap.querySelectorAll('.pdp__variant-group').forEach((group) => {
      const idx = parseInt(group.dataset.optionIndex, 10);
      const active = group.querySelector('.pdp__variant-option.is-active');
      if (active) optionState[idx] = active.dataset.optionValue;
    });

    function applyVariant() {
      const productJsonEl = document.querySelector('script[type="application/json"][data-product-json]');
      // If no JSON blob exists, we still update the visual state but don't swap IDs
      if (!productJsonEl) return;
      let product;
      try { product = JSON.parse(productJsonEl.textContent); } catch { return; }
      const optionValues = Object.keys(optionState).sort().map((k) => optionState[k]);
      const variant = (product.variants || []).find((v) => {
        return optionValues.every((val, i) => v.options[i] === val);
      });
      if (!variant) return;
      const idInput = wrap.querySelector('[data-variant-id-input]');
      if (idInput) idInput.value = variant.id;
      const addBtn = wrap.querySelector('[data-pdp-add-btn]');
      const lbl = wrap.querySelector('[data-pdp-add-label]');
      if (addBtn) addBtn.disabled = !variant.available;
      if (lbl) lbl.textContent = variant.available ? `Add to Cart · ${(variant.price/100).toFixed(2)}` : 'Sold Out';
    }

    wrap.querySelectorAll('.pdp__variant-option').forEach((btn) => {
      btn.addEventListener('click', () => {
        const pos = parseInt(btn.dataset.optionPosition, 10) - 1;
        const val = btn.dataset.optionValue;
        const group = btn.closest('.pdp__variant-group');
        group.querySelectorAll('.pdp__variant-option').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const selectedLabel = group.querySelector('[data-selected-option]');
        if (selectedLabel) selectedLabel.textContent = val;
        optionState[pos] = val;
        applyVariant();
      });
    });
  }

  function setupNewsletter() {
    const form = document.querySelector('.site-footer__newsletter-form');
    if (!form) return;
    form.addEventListener('submit', () => {
      const btn = form.querySelector('button');
      if (btn) btn.textContent = 'Subscribing…';
    });
  }

  // --- Video sound nudge: tap to unmute the nearest video ---
  function setupVideoSound() {
    document.querySelectorAll('[data-sound-nudge]').forEach((nudge) => {
      let el = nudge.parentElement;
      let video = null;
      while (el && !video) { video = el.querySelector('video'); el = el.parentElement; }
      if (!video) { nudge.style.display = 'none'; return; }
      const label = nudge.querySelector('[data-sound-label]');
      const offText = label ? label.textContent : '';
      nudge.addEventListener('click', () => {
        video.muted = !video.muted;
        if (!video.muted) {
          video.play().catch(() => {});
          if (label) label.textContent = 'Sound on — tap to mute';
          nudge.classList.add('is-on');
        } else {
          if (label) label.textContent = offText;
          nudge.classList.remove('is-on');
        }
      });
    });
  }

  function init() {
    setupMobileNav();
    setupAjaxCart();
    setupCartPage();
    setupPdp();
    setupCollectionFilter();
    setupNewsletter();
    setupVideoSound();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
